const getClientShouldUseCookielessMode = () => {
  if (
    typeof navigator !== 'undefined' &&
    navigator.globalPrivacyControl === true
  ) {
    return true;
  }

  if (typeof window !== 'undefined' && window.OnetrustActiveGroups) {
    return window.OnetrustActiveGroups.split(',').length <= 4;
  }

  return false;
};

export default getClientShouldUseCookielessMode;
